enum MixpanelEvent {
  AppClosed = "app_closed",
  AppLoaded = "app_loaded",
  SignUp = "sign_up",
  UserInfoLoaded = "user_info_loaded",
  WalletConnectedByUser = "wallet_connected_by_user",
  WalletDisconnectedByUser = "wallet_disconnected_by_user",
}

export default MixpanelEvent;
